import { environment as defaultEnvironment } from './environment.defaults';
export const environment = {
  ...defaultEnvironment,
  production: true,
  apiPath: ' https://yashica-api.goldsoftng.com/',
  log: false,
  flags: {
    useNewHeader: false
 }
};